import React from "react"
import s from "./BackButton.module.scss"
import cx from "classnames"

import BtnBack from "assets/svg/btn-back.svg"

BackButton.defaultProps = {}

export default function BackButton({ onClick, id, className, ...rest }) {
  return (
    <button
      {...rest}
      id={id}
      className={cx("link", s.BackButton, className)}
      onClick={onClick}
    >
      <img src={BtnBack} alt="Go back" />
    </button>
  )
}
